import React from 'react';

export default function Header({ onToggleTheme, theme }) {
  return (
    <header style={{ alignItems: 'flex-start' }}>
      <div className="hdr-l" style={{ paddingTop: '4px' }}>
        <img
          src={theme === 'dark' ? '/logo-dark.png' : '/logo-light.png'}
          alt="AIx Navigator"
          style={{ height: '64px', width: 'auto' }}
          data-testid="header-logo"
        />
      </div>
      <div className="hdr-r">
        <button
          className="pill"
          onClick={onToggleTheme}
          aria-label="Toggle theme"
          data-testid="theme-toggle"
        >
          <span>{theme === 'dark' ? '\u{1F319}' : '\u{2600}\u{FE0F}'}</span> Theme
        </button>
      </div>
    </header>
  );
}
